import { EXAM_PACK_SETS, LEGACY_PACK_SETS, ORDINARY_PACK_SETS, renderPackDrawing, } from './pack.js';
export const CHALLENGE_SECONDS = 18;
export const CHALLENGE_VERSION = 'v3';
export function hashSeed(text) {
    let hash = 2166136261;
    for (let i = 0; i < text.length; i++)
        hash = Math.imul(hash ^ text.charCodeAt(i), 16777619);
    return hash >>> 0;
}
export function seededRandom(seed) {
    let state = seed >>> 0;
    return () => {
        state = (Math.imul(1664525, state) + 1013904223) >>> 0;
        return state / 4294967296;
    };
}
export function validChallengeId(id) {
    if (/^v1-[0-9a-z]{1,10}$/.test(id))
        return true;
    const match = /^(v2|v3)-([0-9a-z]{1,3})-[0-9a-z]{1,10}$/.exec(id);
    if (!match)
        return false;
    const bank = match[1] === 'v2' ? ORDINARY_PACK_SETS : EXAM_PACK_SETS;
    return parseInt(match[2], 36) < bank.length;
}
export function dailyChallengeId(date = new Date()) {
    const day = Math.floor(date.getTime() / 86400000);
    const index = ((day % EXAM_PACK_SETS.length) + EXAM_PACK_SETS.length) % EXAM_PACK_SETS.length;
    return `v3-${index.toString(36)}-${hashSeed(date.toISOString().slice(0, 10)).toString(36)}`;
}
export function newChallengeId(excludeFamilies = new Set(), rng = Math.random) {
    const fresh = EXAM_PACK_SETS.map((set, index) => ({ set, index })).filter(({ set }) => !excludeFamilies.has(set.family ?? set.id));
    const index = fresh.length
        ? fresh[Math.floor(rng() * fresh.length)].index
        : Math.floor(rng() * EXAM_PACK_SETS.length);
    return `v3-${index.toString(36)}-${Math.floor(rng() * 0x100000000).toString(36)}`;
}
export function newOddChallengeId(excludeFamilies = new Set(), rng = Math.random) {
    const fresh = ORDINARY_PACK_SETS.map((set, index) => ({ set, index })).filter(({ set }) => !excludeFamilies.has(set.family ?? set.id));
    const index = fresh.length
        ? fresh[Math.floor(rng() * fresh.length)].index
        : Math.floor(rng() * ORDINARY_PACK_SETS.length);
    return `v2-${index.toString(36)}-${Math.floor(rng() * 0x100000000).toString(36)}`;
}
export function stageTimeline(strokes, durationMs) {
    // Put distinguishing features into the scoring window; decorative details finish last.
    const weights = [0, 0.1, 0.15, 0.4, 0.35];
    let cursor = 0;
    return [1, 2, 3, 4].map((index) => {
        const startMs = cursor;
        cursor = index === 4 ? durationMs : cursor + Math.round(durationMs * weights[index]);
        return { index, strokes: strokes.filter((s) => s.stage === index), startMs, endMs: cursor };
    });
}
/** Published bank orders are immutable. Existing v1/v2 links retain their original answer. */
export function challengeFor(id) {
    if (!validChallengeId(id))
        throw new Error('Invalid challenge');
    const rng = seededRandom(hashSeed(id));
    const set = id.startsWith('v1-')
        ? LEGACY_PACK_SETS[Math.floor(rng() * 24)]
        : id.startsWith('v2-')
            ? ORDINARY_PACK_SETS[parseInt(id.split('-')[1], 36)]
            : EXAM_PACK_SETS[parseInt(id.split('-')[1], 36)];
    const order = [0, 1, 2, 3];
    for (let i = order.length - 1; i > 0; i--) {
        const j = Math.floor(rng() * (i + 1));
        [order[i], order[j]] = [order[j], order[i]];
    }
    const correctIndex = Math.floor(rng() * 4);
    return {
        id,
        set,
        order,
        texts: order.map((si) => set.sentences[si].text),
        correctLetterIndex: order.indexOf(correctIndex),
        drawing: renderPackDrawing(set, correctIndex),
    };
}
//# sourceMappingURL=challenge.js.map